import React from 'react';
import Body from './components/body'

function App() {
return(
  <Body>

  </Body>
)
}

export default App;
